export default Object.freeze({
    TOKEN_KEY: "ls_jwt_token",
});
